import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-d1d0bab0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "cm-ui-dialog-title",
  style: {"padding":"25px 20px"}
}
const _hoisted_2 = { class: "drawer-wrapper cm-ui-ht100" }

import { ref, reactive, computed, watch, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import CmTable from '@/components/cmTable/index.vue'
import { TerminalViewService, TerminalItem, DetailItem, DetailQueryParams } from '../terminal-view/terminal-view.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'terminal-detail-drawer',
  props: {
    modelValue: { type: Boolean },
    baseInfo: {},
    direction: {},
    initialTab: { default: 'active-boot-item' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n()
const bootTypeDict = computed(() => ['', t('bootOptimize.bootTypeMenu'), t('bootOptimize.bootTypeTask'), t('bootOptimize.bootTypeRegSoft'), t('bootOptimize.bootTypeRegService')])
const bootSuggestDict = computed(() => ['', t('bootOptimize.suggestClose'), t('bootOptimize.suggestCareful')])

const props = __props

const emit = __emit

const injector = useReflectiveInjector([TerminalViewService])
const terminalService = injector.get(TerminalViewService)

const drawerVisible = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})

const direction = computed(() => props.direction || 'rtl')
const activeState = ref(props.initialTab)
const activeTableRef = ref()
const unoptimizedTableRef = ref()
const optimizedTableRef = ref()

const activeQueryParams = reactive<DetailQueryParams>({
  device_id: props.baseInfo.device_id || '',
  optimize_type: 0,
  page: 1,
  limit: 20
})

const unoptimizedQueryParams = reactive<DetailQueryParams>({
  device_id: props.baseInfo.device_id || '',
  optimize_type: 2,
  page: 1,
  limit: 20
})

const optimizedQueryParams = reactive<DetailQueryParams>({
  device_id: props.baseInfo.device_id || '',
  optimize_type: 1,
  page: 1,
  limit: 20
})

watch(
  () => props.baseInfo?.device_id,
  (id) => {
    const d = id || ''
    activeQueryParams.device_id = d
    unoptimizedQueryParams.device_id = d
    optimizedQueryParams.device_id = d
    activeQueryParams.page = 1
    unoptimizedQueryParams.page = 1
    optimizedQueryParams.page = 1
  },
  { immediate: true }
)

const tableOpt = computed(() => ({
  columns: [
    { prop: 'app_name', label: t('bootOptimize.name') },
    { prop: 'description', label: t('bootOptimize.description') },
    { prop: 'soft_name', label: t('bootOptimize.appName') },
    {
      prop: 'autorun_type',
      label: t('bootOptimize.autorunType'),
      formatter: (row: DetailItem) => bootTypeDict.value[row.autorun_type] || ''
    },
    {
      prop: 'suggest_action',
      label: t('bootOptimize.suggestAction'),
      formatter: (row: DetailItem) => bootSuggestDict.value[row.suggest_action] || ''
    }
  ],
  usePagination: false,
  showSearch: false,
  showForm: false,
  showActionBar: false,
  showRightToolbar: false,
  path: 'list',
  totalPath: 'total'
}))

const pageOption = {
  pageNumName: 'page',
  pageSizeName: 'limit'
}

function getListApi(params: DetailQueryParams) {
  return terminalService.fetchDetailList(params)
}

function clickTab(tab: any) {
  activeState.value = tab.props.name
  // 切换 tab 时刷新对应表格
  nextTick(() => {
    if (tab.props.name === 'active-boot-item') {
      activeTableRef.value?.getList()
    } else if (tab.props.name === 'unoptimized-item') {
      unoptimizedTableRef.value?.getList()
    } else if (tab.props.name === 'optimized-item') {
      optimizedTableRef.value?.getList()
    }
  })
}

function handleClose() {
  drawerVisible.value = false
}

watch(() => props.modelValue, (val) => {
  if (val) {
    // 打开抽屉时切换到指定的 tab 并刷新表格
    activeState.value = props.initialTab
    nextTick(() => {
      if (activeState.value === 'active-boot-item') {
        activeTableRef.value?.getList()
      } else if (activeState.value === 'unoptimized-item') {
        unoptimizedTableRef.value?.getList()
      } else if (activeState.value === 'optimized-item') {
        optimizedTableRef.value?.getList()
      }
    })
  }
})

watch(() => props.initialTab, (newTab) => {
  if (props.modelValue) {
    activeState.value = newTab
    nextTick(() => {
      if (activeState.value === 'active-boot-item') {
        activeTableRef.value?.getList()
      } else if (activeState.value === 'unoptimized-item') {
        unoptimizedTableRef.value?.getList()
      } else if (activeState.value === 'optimized-item') {
        optimizedTableRef.value?.getList()
      }
    })
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    size: "70%",
    modelValue: drawerVisible.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((drawerVisible).value = $event)),
    direction: direction.value,
    "before-close": handleClose,
    "destroy-on-close": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createTextVNode(_toDisplayString(_ctx.$t('bootOptimize.terminalBootListTitle', { name: _ctx.baseInfo.computer_name || _ctx.$t('bootOptimize.unnamedTerminal') })) + " ", 1),
        _createVNode(_component_el_pagination, {
          style: {"visibility":"hidden"},
          layout: "sizes"
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_tabs, {
          class: "content-adapt",
          modelValue: activeState.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((activeState).value = $event)),
          onTabClick: clickTab
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('bootOptimize.tabActiveBoot'),
              name: "active-boot-item"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(CmTable, {
                  key: 'active-' + _ctx.baseInfo.device_id,
                  ref_key: "activeTableRef",
                  ref: activeTableRef,
                  "table-opt": tableOpt.value,
                  api: getListApi,
                  "page-option": pageOption,
                  modelValue: activeQueryParams,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeQueryParams) = $event))
                }, null, 8, ["table-opt", "modelValue"]))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('bootOptimize.tabOptimizable'),
              name: "unoptimized-item"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(CmTable, {
                  key: 'unoptimized-' + _ctx.baseInfo.device_id,
                  ref_key: "unoptimizedTableRef",
                  ref: unoptimizedTableRef,
                  "table-opt": tableOpt.value,
                  api: getListApi,
                  "page-option": pageOption,
                  modelValue: unoptimizedQueryParams,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((unoptimizedQueryParams) = $event))
                }, null, 8, ["table-opt", "modelValue"]))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('bootOptimize.tabOptimizedItems'),
              name: "optimized-item"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(CmTable, {
                  key: 'optimized-' + _ctx.baseInfo.device_id,
                  ref_key: "optimizedTableRef",
                  ref: optimizedTableRef,
                  "table-opt": tableOpt.value,
                  api: getListApi,
                  "page-option": pageOption,
                  modelValue: optimizedQueryParams,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((optimizedQueryParams) = $event))
                }, null, 8, ["table-opt", "modelValue"]))
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "direction"]))
}
}

})